import { OwnerDetailPage } from './OwnerDetailPage';

export default OwnerDetailPage;
